import { StateField } from "@codemirror/state";
import { setDiagnosticsEffect, type Diagnostic } from "@codemirror/lint";

export const lintState = StateField.define<readonly Diagnostic[]>({
  create: () => [],
  update(value, tr) {
    const effect = tr.effects.find(e => e.is(setDiagnosticsEffect));
    if (effect) {
      return effect.value;
    }
    
    let mapped = value;
    if (tr.changes.length) {
        let newDiags = [];
        for (let d of value) {
            let from = tr.changes.mapPos(d.from, -1);
            let to = tr.changes.mapPos(d.to, 1);
            if (from < to) {
                newDiags.push({...d, from, to});
            }
        }
        mapped = newDiags;
    }
    return mapped;
  },
});
